import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SecureNameType } from '../../shared/types/secure-name.type';
import { FormGroup } from '@angular/forms';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ActivatedRoute } from '@angular/router';
import { ReceiveInfoBrokerService } from 'src/app/core/providers/services/receive-info-broker/receive-info-broker.service';
import { ProductosMediadoresService } from 'src/app/core/providers/services/productos-mediadores/productos-mediadores.service';
import { Numbers } from 'src/app/utils/constants';
import { ProductIdCorreduria } from 'src/app/core/interfaces/producto-informacion.interface';


@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit, OnDestroy {

  /**
   * @description Es el formulario
   */
  @Input() FORM_DATA: FormGroup;

  /**
   * @description Subject para finalizar las suscriciones
   */
  private finishSubscriptions = new Subject();

  /**
   * @description Elegimos el tipo de formulario a mostrar
   */
  @Input() SECURE_TYPE: SecureNameType;

  /**
   * @description Para emitir el valor del formulario entero a quien haga uso del modulo
   */
  @Output() FORM_VALUE: EventEmitter<any> = new EventEmitter();
  @Output() S_THANKS: EventEmitter<any> = new EventEmitter();
  @Output() brokerInfo: EventEmitter<any> = new EventEmitter();

  tokenURL: any = '';
  productosId: any = [];
  productos: any = [];

  /**
   * @description constructor
   * @params gtmService
   */
  constructor(
    private gtmService: GoogleTagManagerService,
    private activatedRoute: ActivatedRoute,
    private brokerService: ReceiveInfoBrokerService,
    private productosMediadoresService: ProductosMediadoresService
  ) {
    this.gtmService = gtmService;
    this.activatedRoute = activatedRoute;
    this.brokerService = brokerService;
    this.productosMediadoresService = productosMediadoresService;

    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params.token !== undefined) {
        this.tokenURL = params.token;
      } else {
        this.tokenURL = '';
      }
      setTimeout(() => {
        this.getInfoBroker();
      }, Numbers.number40);
    });

  }
  /**
   * @description Metodo de inicio
   */
  ngOnInit(): void {
    this.initForm();
    this.emitFormChanges();
  }
  /**
   * @description Metodo de fin
   */
  ngOnDestroy() {
    this.finishSubscriptions.next(true);
  }

  /**
   * @description Inicializacion del formulario
   */
  private initForm(): void {
    this.datalayer();
  }

  /**
   * @description En cada cambio del formulario se emite el formulario entero
   */
  private emitFormChanges(): void {
    if (this.FORM_DATA) {
      this.FORM_DATA.valueChanges
        .pipe(
          takeUntil(this.finishSubscriptions),
          tap(changedData => {
            this.FORM_VALUE.emit(this.FORM_DATA.value);
          })
        ).subscribe();
    }
  }

  /**
   * @description Se define el mensaje de gracias para los formularios sin TPV
   */
  public modifyStepT(ev: 'thanks' | ''): void {
    if (ev === 'thanks') {
      this.S_THANKS.emit({ thanks: true });
    }
  }

  /**
   * @description recupera información de la correduría
   */
  getInfoBroker(): void {
    const formName: any = this.FORM_DATA.get('insureSelected').value;
    if (this.tokenURL !== '') {
      this.brokerService.getInfoBroker(this.tokenURL)
        .pipe()
        .subscribe((el: any) => {
          this.FORM_DATA.get([formName.chosed, 'idCorreduria']).setValue(el.id_correduria);
          this.FORM_DATA.get([formName.chosed, 'logoCorreduria']).setValue(el.url);
          this.brokerInfo.emit({ showBrokerLogo: true, urlBrokerLogo: el.url });

          this.getBrokerGuarantee(el.id_correduria);
        });
    } else {
      this.productosId = [0];

    }
  }

  /**
   * @description recupera las garantías de la correduría
   */
  getBrokerGuarantee(idCorreduria: string): void {
    const idformSet: string = localStorage.getItem('idform');
    this.productosMediadoresService.getProductosMediadores(idCorreduria, idformSet)
      .pipe()
      .subscribe((pm: any) => {
        if (pm && pm.productos) {
          this.productosId = pm.productos;
        } else {
          this.productosId = [];
        }
      });
  }

  /**
   * @description asignar evento analítica
   */
  datalayer(): void {
    const formName: any = this.FORM_DATA.get('insureSelected').value;
    const urlLink = location.origin + location.pathname;
    const datalayerD: any = {
      page_url: urlLink,
      user_id: '-',
      seccion: formName.layerName
    };
    this.gtmService.pushTag(datalayerD);
  }
}
